export const VEDIC_FORMAT_CURRENCIES: string[] = [];

export const DEFAULT_TIMER_FORMAT = 'hMS';
